// extracted by mini-css-extract-plugin
module.exports = {"EUFlashSale":"Products_EUFlashSale__u715M"};